import I18n from "../../../../commons/I18n/I18n";
import ScreenCard from "../../../../components/screen/ScreenCard";
import { AppIcon } from "../../../../config/Config";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_ADMIN_PARKING_LOSS_REASONS } from "../../../../routing/Routes";
import ParkingLossReasonListCardAdmin from "./ParkingLossReasonListCardAdmin";

const ParkingLossReasonListAdminScreen = () =>(
  <ScreenCard breadcrumbs={[
    {
      name: I18n.tr(I18nKeys.MOTIVOS_DE_PLAZAS_PERDIDAS),
      url: ROUTE_ADMIN_PARKING_LOSS_REASONS,
      icon: AppIcon.PARKING,
    },
  ]}>
    <ParkingLossReasonListCardAdmin/>
  </ScreenCard>
);

export default ParkingLossReasonListAdminScreen;
